// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xIhO","name":"Header_name__1NIZ8","birthday":"Header_birthday__3TxQU","skeleton":"Header_skeleton__2IK1-"};